import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import "./modern-theme.css";
import ProcedureRequest from "./ProcedureRequest";
import { getDocumento } from "../../reducers/documento";

import ProcedureCharge from "./ProcedureCharge";
import ProcedureSignature from "./ProcedureSignature";
import ProcedurePixel from "./ProcedurePixel";
import ProcedureForm from "./ProcedureForm";
import ProcedureMail from "./ProcedureMail";
import ProcedureParticipants from "./ProcedureParticipants";
import ProcedureReview from "./ProcedureReview";
import ProcedureLogin from "./ProcedureLogin";
import ProcedureSiteEmbebed from "./ProcedureSiteEmbebed";
import ProcedureEnd from "./ProcedureEnd";
import ProcedureOdoo from "./ProcedureOdoo";
import ProcedureUpload from "./ProcedureUpload";
import ProcedureRescue from "./ProcedureRescue";
import ProcedureExtractor from "./ProcedureExtractor";

import logo from "../../logoGestdoc.svg"; // Tell webpack this JS file uses this image
import Profile from "./Profile";

import ProcedureLoading from "./ProcedureLoading";
import ProcedureBack from "./ProcedureBack";
import ProcedureError from "./ProcedureError";

import { vistaPagina, evento } from "../../utils/matomo";

// Nombre del paso en la URL medida (según custom:functions del BPMN)
const PASOS_MATOMO = {
  charge: "pago",
  form: "formulario",
  email: "correo",
  doc: "revision",
  advanced_signature: "firma-avanzada",
  request_signature: "solicitar-firma",
  signature: "firma",
  view_collaborations: "participantes",
  sign_in: "ingreso",
  get_Info_odoo: "odoo",
  insert_site: "sitio",
  upload: "subir",
  extractor: "extractor",
  END: "fin",
};

export default function Procedure() {
  const dispatch = useDispatch();
  const { transaction, participant } = useParams();
  const { documento, loading, error, updated, origin, url } = useSelector(({ documento }) => documento);
  const [intervalApiPixel, setIntervalApiPixel] = useState();
  const [show, setShow] = useState(false);

  const isAuth = useSelector(({ auth }) => auth.token !== null);

  let participantData = null;
  if (participant && documento) {
    participantData = documento.participants.find((it) => it.id === participant);
  } else if (documento) {
    participantData = documento.participants[0];
  }

  useEffect(() => {
    dispatch(getDocumento(transaction));
    // eslint-disable-next-line
    if (participantData) {
      if (participantData.next["custom:functions"] === "signature") {
        setIntervalApiPixel(true);
      }
    }
    // eslint-disable-next-line
  }, [transaction, updated]);

  useEffect(() => {
    function getAlerts() {
      dispatch(getDocumento(transaction));
    }
    if (intervalApiPixel) {
      getAlerts();
      const interval = setInterval(() => getAlerts(), 20 * 1000);
      // TODO: la idea es que esto llegue a  case 'END': en el caso de   switch (participantData.next['custom:functions']) {
      return () => {
        clearInterval(interval);
      };
    }
    // eslint-disable-next-line
  }, [intervalApiPixel]);

  // Embudo: una vista por paso del trámite (URL sin IDs). El polling y los re-render no la repiten
  const pasosMedidos = useRef(new Set());
  useEffect(() => {
    if (!documento || loading || error || !participantData) return;
    const funcion = participantData.next && participantData.next["custom:functions"];
    if (!funcion) return;
    const clave = `${participantData.id}:${participantData.next.id || funcion}`;
    if (pasosMedidos.current.has(clave)) return;
    pasosMedidos.current.add(clave);
    const paso = PASOS_MATOMO[funcion] || funcion;
    vistaPagina(`/procedure/${paso}`, `Trámite - ${paso}`);
    evento("Embudo", funcion === "END" ? "Trámite finalizado" : `Paso ${paso}`, documento._nameSchema);
    // eslint-disable-next-line
  }, [documento, loading, error, participantData && participantData.id, participantData && participantData.next]);

  if (origin) {
    if (origin === "rescue") {
      return <ProcedureRescue />;
    }
  }

  const handleClose = () => {
    setShow(false);
  };
  const handleBack = () => {
    setShow(true);
  };

  let currentContent = <span>cargando...</span>;
  if (participantData) {
    switch (participantData.next["custom:functions"]) {
      case "charge":
        currentContent = <ProcedureCharge handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "form":
        currentContent = <ProcedureForm handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "email":
        currentContent = <ProcedureMail handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "doc":
        currentContent = <ProcedureReview handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "advanced_signature":
        currentContent = <ProcedureSignature handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "request_signature":
        currentContent = <ProcedureRequest handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "signature":
        currentContent = <ProcedurePixel handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "view_collaborations":
        currentContent = <ProcedureParticipants />;
        break;
      case "sign_in":
        currentContent = <ProcedureLogin handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "get_Info_odoo":
        currentContent = <ProcedureOdoo handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "insert_site":
        currentContent = <ProcedureSiteEmbebed handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "upload":
        currentContent = <ProcedureUpload handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "extractor":
        currentContent = <ProcedureExtractor handleBack={handleBack} canGoBack={participantData.previous} />;
        break;
      case "END":
        currentContent = <ProcedureEnd />;
        break;
      default:
        currentContent = <span>Falta información</span>;
        break;
    }
  }

  if (error) {
    return <ProcedureError />;
  }
  if (!documento || loading) {
    return (
      <>
        <div
          style={{
            height: "50px",
            backgroundColor: "#1d0c8e",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <img
              style={{
                height: "33px",
                padding: "30px",
                paddingLeft: "65px",
              }}
              src={logo}
              alt="Logo Gestdoc"
            />
          </div>
          <div>{isAuth && <Profile />}</div>
        </div>
        <div style={{ backgroundColor: "#f1f4fb" }}>
          <ProcedureLoading />
        </div>
      </>
    );
  }
  return (
    <>
      <div
        className="gd-proc-nav"
        style={{
          height: "50px",
          backgroundColor: "#1d0c8e",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <img
            className="gd-proc-nav__logo"
            style={{
              height: "33px",
              padding: "30px",
              paddingLeft: "65px",
            }}
            src={logo}
            alt="Logo Gestdoc"
          />
        </div>
        <div className="gd-proc-nav__right" style={{ display: "flex", alignItems: "center", paddingRight: 24 }}>
          {participantData.previous && (
            <ProcedureBack open={show} handleClose={handleClose} gestor={participantData} transaction={transaction} />
          )}
          {isAuth && (
            <Link to="/orders" className="gd-nav-link" title="Volver a mis trámites" aria-label="Volver a mis trámites">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              <span className="gd-nav-link__t">Mis trámites</span>
            </Link>
          )}
          {isAuth && <Profile />}
        </div>
      </div>
      <div style={{ backgroundColor: "#f1f4fb" }}>{currentContent}</div>
    </>
  );
}
